const dynamicFormModule = window.dynamicFormModule;
export const createItemForDynamicForm = dynamicFormModule.createItemForDynamicForm;
export const validateDataByDataField = dynamicFormModule.validateDataByDataField;